import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=81b3f25e&"
import script from "./Loader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Loader.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports